import { createFileRoute } from '@tanstack/react-router';
import { ProjectCardPage } from '../features/records/ProjectCardPage';
import { validateCardSearch } from '../lib/cardSearch';

export const Route = createFileRoute('/projects/$id')({
  validateSearch: validateCardSearch,
  component: function CardRoute() {
    const { id } = Route.useParams();
    return <ProjectCardPage id={id} />;
  },
});
